import { v4 as uuidv4 } from "uuid";
export class CategoryModel {
    constructor() {
        this.id = uuidv4();
        this.categoryName = "";
        this.description = "";
        this.exportSortOrder = null;
        this.reportTags = [];
        this.entryCount = 0;
    }
}
export default class Category extends CategoryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
